module.exports = __webpack_public_path__ + "media/images/countrysquared/tz-5156d3bb8f2692069d960cc30b8ce038.svg";